export const COUNTRIES_QUERY = `
  {
      countries {
          title: name
          id: code
      }
  }
`;

export const TAGS_QUERY = `
  {
    tags{
      id,
      title: text
    }
  }
`;

export const LITTER_REPORT_QUERY = `
  query litter_report_query(
       $tagIds: [Int],
       $countryCodes: [String]
       $zipCity: String,
       $radius: Int,
       $startDate: Float,
       $endDate: Float,
       $offset: Int,
       $limit: Int
    ){
      litters_report(
         tagIds: $tagIds,
         countryCodes: $countryCodes,
         zipCity: $zipCity,
         radius: $radius,
         startDate: $startDate,
         endDate: $endDate,
         offset: $offset,
         limit: $limit
     ){
       id,
       tags,
       location,
       country,
       createdAt: photoTimestamp,
       thumbnail
     }
}
`;

export const LITTER_REPORT_COUNT_QUERY = `
  query litter_report_query_count(
       $tagIds: [Int],
       $countryCodes: [String]
       $zipCity: String,
       $radius: Int,
       $startDate: Float,
       $endDate: Float,
       $offset: Int,
       $limit: Int
    ){
      litter_report_count(
         tagIds: $tagIds,
         countryCodes: $countryCodes,
         zipCity: $zipCity,
         radius: $radius,
         startDate: $startDate,
         endDate: $endDate,
         offset: $offset,
         limit: $limit
     )
}
`;

export const FORM_DETAILS_MUTATION = `
    mutation send_form_details(
        $name: String,
        $email: String,
        $phone: String,
        $organization: String,
        $purpose: String,
        $reference: String,
        $extraInfo: String,
        $expandedData: String
    ){
        submit_form_data(
            name: $name,
            email: $email,
            phone: $phone,
            organization: $organization,
            purpose: $purpose,
            reference: $reference,
            extraInfo: $extraInfo,
            expandedData: $expandedData
        )
      }
`;

export const REPORT_SCHEDULER_MUTATION = `
    mutation save_litter_report_scheduler(
      $email: String,
      $format: String,
      $formatType: String,
      $tagIds: [Int],
      $countryCodes: [String],
      $zipCity: String,
      $radius: Int,
      $startDate: Float,
      $endDate: Float,
      $campaign: Boolean,
    ){
    save_report_scheduler(
         email: $email,
         fileFormat: $format,
         fileFormatType: $formatType,
         tagIds: $tagIds,
         countryCodes: $countryCodes,
         zipCity: $zipCity,
         radius: $radius,
         startDate: $startDate,
         endDate: $endDate,
         campaign: $campaign
       )
    }
`;
